import { PortalWorkoutPlanFragment } from '@willow/graphql-iso/src/portal';
import { assertNever, paymentAmountFormat } from '@willow/shared-web';

import { AlertWrapper } from './AlertWrapper';

export const ActiveWorkoutPlanAlert = ({
  activeWorkoutPlan,
  totalAmountDue,
}: {
  activeWorkoutPlan: PortalWorkoutPlanFragment | undefined;
  totalAmountDue: number;
}) => {
  if (!activeWorkoutPlan) return null;

  let { title, subtitle } = {
    title: '',
    subtitle: `${paymentAmountFormat(totalAmountDue)} payment will reinstate the loan in full`,
  };
  switch (activeWorkoutPlan.__typename) {
    case 'FlexModificationWorkoutPlan':
      title = 'Active trial flex modification in place';
      break;
    case 'ForbearanceWorkoutPlan':
      title = 'Active forbearance in place';
      break;
    case 'RepaymentWorkoutPlan':
      title = 'Active repayment plan in place';
      break;
    case 'DefermentWorkoutPlan':
    case 'PaymentDeferralWorkoutPlan':
    case 'BankruptcyCh13WorkoutPlan':
      return <></>;
    default:
      assertNever(activeWorkoutPlan);
  }

  return <AlertWrapper title={title} subtitle={subtitle} level="ERROR" />;
};
